import { Component } from '@angular/core';
import { FingeringDiagramBaseComponent } from '../fingering-diagram-base/fingering-diagram-base.component';

@Component({
  selector: 'app-emeo-diagram-saxophone-v1',
  templateUrl: './emeo-diagram-saxophone-v1.component.svg',
  styleUrls: ['./emeo-diagram-saxophone-v1.component.scss']
})
export class EmeoDiagramSaxophoneV1Component extends FingeringDiagramBaseComponent {

  constructor()
  { 
    super();
  }

}
